import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/** Redirect legacy public purchase URLs to the new short paths. */
export function LegacyBuyTicketsRedirect() {
  const { id } = useParams();
  return <Navigate to={`/comprar/${id}`} replace />;
}

export function LegacyBoardRedirect() {
  const { id } = useParams();
  return <Navigate to={`/tablero/${id}`} replace />;
}

export function LegacyCheckoutRedirect() {
  const { id } = useParams();
  return <Navigate to={`/pago/${id}`} replace />;
}

export function LegacyReserveRedirect() {
  return <Navigate to='/reserva' replace />;
}

export function LegacyReserveBoardRedirect() {
  return <Navigate to='/reserva-tablero' replace />;
}
